import { DynPanelAware } from '@/components/dyn-panel';
import { CommitableSlidePanel } from "@/components/slide-panel";
import RightsAware from '@/lib/mixins/rights-aware';
import User, { FLEX_PROFILES } from '@/lib/models/user';
import { Component, Mixins } from "vue-property-decorator";
import { getAllUsers, saveUser } from '@/lib/services';
import XTable from '@/components/x-table';
import XTh from '@/components/x-table/x-th';
import ActionTH from '@/components/x-table/action-th';
import ActionTd from '@/components/x-table/action-td';
import PanelUser from '../components/panel-user';
import { Getter, Mutation } from 'vuex-class';

@Component
export default class Admin extends Mixins<CommitableSlidePanel, RightsAware, DynPanelAware>(CommitableSlidePanel, RightsAware, DynPanelAware) {

  @Getter loggedUser;
  @Mutation updateLoggedUserDepts;

  protected data: User[] = null;
  
  get rootClasses() {
    return ["is-fullwidth"];
  }

  mounted() {
    this.loadData();
  }

  async loadData() {
    this.data = await getAllUsers();
  }

  onClickCancel() {
    this.$router.push({name: "index"});
  }

  onClickEditUser(d) {
    this.pushPanel({
      clazz: PanelUser,
      props: {edit: d, readonly: this.isReadonly},
      on: {
        commit: async ({emitter, data: user}) => {
          await saveUser({user});
          await this.loadData();
          if (user.mail === this.loggedUser.mail) {
            this.updateLoggedUserDepts(user.depts);
          }
          emitter.remove()
        },
        cancel: ({emitter}) => emitter.remove()
      }
    })
  }

  renderHead() {
    return (
      <span>Administration des utilisateurs</span>
    );
  }

  renderBody() {
    if (!this.data) return <div class="async is-loading is-large" style="height: 50vh"></div>;
    return (
      <div style="height: 70vh; overflow: scroll;">
        <div class="is-flex">
          {this.renderUserTable()}
        </div>
      </div>
    );
  }

  renderFooter() {
    if (!this.data) return null;
    return (
      <div class="columns is-fluid">
         <div class="column is-10"></div>
        <div class="column is-2 is-flex justify-end">
          <button class="button is-small is-fluid" onClick={this.onClickCancel}>{'Fermer'}</button>
        </div>
      </div>
    );
  }


  renderUserProfil(u: User) {
    if (u.hasFlexProfile(FLEX_PROFILES.AGENT_SAISIE)) {
      return "Agent de saisie";
    } else if (u.hasFlexProfile(FLEX_PROFILES.VALIDEUR)) {
      return "Valideur";
    } else if (u.hasFlexProfile(FLEX_PROFILES.REF_THEM)) {
      return "Référent thématique";
    }
    return "";
  }

  renderUserDepts(u: User) {
    if (u.depts === "ALL") return <span class="tag is-success">Tous</span>;
    if (u.depts?.length) {
      return u.depts.split(",").map(s => <span class="tag is-light">{s.trim()}</span>)
    }
    return "Aucun";
  }

  renderUserTable() {
    return (
      <XTable class={`table is-striped is-fullwidth`}
        data={this.data}
        scopedSlots={{
          header: () => (
            <tr>
              <XTh prop="nomCavite">Mail</XTh>
              <XTh prop="typeCavite">Nom</XTh>
              <XTh prop="commune.nom">Profil</XTh>
              <XTh prop="xouv93">Départements</XTh>
              <ActionTH/>
            </tr>
          ),
          row: ({d}: {d: User}) => (
            <tr>
              <td>{d.mail}</td>
              <td>{d.nom}</td>
              <td>{this.renderUserProfil(d)}</td>
              <td>{this.renderUserDepts(d)}</td>
              <ActionTd withDelete={false}
                onEdit={() => this.onClickEditUser(d)}/>
            </tr>
          )
        }}>
      </XTable>
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-586f24b4/index.tsx" });